import React from 'react';

export default {

  // menu settings
  menus: {
    // table sidebar menu
    sidebar: {
      menuItems: [],
      // menuItems: [
      //   {
      //     title: 'Download',
      //     id: 'dls',
      //     options: [
      //       {
      //         text: 'CSV file(Comma Delimited)' ,
      //         id: 'csv',
      //         setterParam: 'csv',
      //         setter: 'fileDownload',
      //       },
            // {
            //   text: 'JSON',
            //   id: 'json',
            //   setterParam: 'json',
            //   setter: 'fileDownload',
            // }
        //   ]
        // },
      // ],
      actions: {},
    },
      //bottom toolbar menu
      toolbarBottom: {},
      // bottom toolbar menu
      toolbarTop: {},
  }, // end of menus

  // --------- group actions
  groupActions: {},


  // --------- dataTable headers
  headers: {
    nct: {
      key: '_id',
      title: 'NCT',
      tip: 'NCT number of the trial.',
      searchable: true,
      width: 120,
    },
    protocol: {
      key: 'protocolId',
      title: 'Protocol',
      tip: 'Protocol ID of the trial.',
      searchable: true,
      width: 120,
    },
    referralOpen: {
      key: 'referralOpen',
      title: 'Open Referral Page',
      tip: 'The referral page was opened during this session',
      searchable: true,
      width: 200,
    },
    launchDate: {
      key: 'launchTime',
      title: 'Launch Time',
      tip: 'The time the session started',
      searchable: true,
      width: 200,
    },
    submissionOpen: {
      key: 'submissionOpen',
      title: 'Submission Made',
      tip: 'Trial submission was made during this session',
      searchable: true,
      width: 200,
    },
    submissionDate: {
      key: 'referralTime',
      title: 'Referral Time',
      tip: 'Times the referral page has been opened',
      searchable: true,
      width: 210,
    },
    referralCount: {
      key: 'referralCount',
      title: 'Reached Referral Page',
      tip: 'Times the referral page has been opened',
      searchable: true,
      width: 210,
    },
    sessionCount: {
      key: 'sessionCount',
      title: 'Session Count',
      tip: 'Times the app was launched',
      searchable: true,
      width: 155,
    },
    submissionCount: {
      key: 'submissionCount',
      title: 'Submissions Made',
      tip: 'Times a submission has been',
      searchable: true,
      width: 185,
    },
    latestDate: {
      key: 'latest',
      title: 'Latest Activity',
      tip: 'Date and time of latest activity by user',
      searchable: true,
      width: 150
    },
    nct_link: {
      key: 'nct_id',
      title: 'NCT',
      tip: 'Identification number of the trial.',
      searchable: true,
      width: 150,
    },
    qc_logs: {
      key: 'reviewLast',
      title: 'QC Logs',
      tip: 'Last action on QC toggle',
      width: 135
    },
    approvedLogs: {
      key: 'displayLogs',
      title: 'Display Logs',
      tip: 'Last action on display toggle',
      width: 135
    },
    platform: {
      key: 'platform',
      title: 'Source',
      tip: 'Platform Used',
      width: 100
    },
    condition: {
      key: 'conditions',
      title: 'Conditions',
      tip: 'Launched conditions',
      width: 'max'
    },
    conditions: {
      key: 'conditions',
      title: 'Conditions',
      tip: 'Conditions of interest',
      width: 250
    },
    gender: {
      key: 'gender',
      title: 'Gender',
      tip: 'Gender of the patient',
      width: 100
    },
    age: {
      key: 'age',
      title: 'Age',
      tip: 'Age of the patient',
      width: 'min'
    },
    primaryCrg: {
      key: 'primaryCrg',
      title: 'CRG',
      tip: 'Primary CRG',
      searchable: true,
      width: 'min'
    },
    primaryMg: {
      key: 'primaryMg',
      title: 'MG',
      tip: 'Primary Management Group',
      searchable: true,
      width: 'min'
    },
    mutationsIn: {
      key: 'mutationsIn',
      title: 'Mutations Present',
      tip: 'Eligible mutations of the patient',
      width: 150
    },
    mutationsOut: {
      key: 'mutationsOut',
      title: 'Mutations Absent',
      tip: 'Ineligible mutations of the patient',
      width: 150
    },
    pscore: {
      key: 'pscore',
      title: 'ECOG Status',
      tip: 'Performance status of the patient',
      width: 120
    },
    broadcastCount: {
      key: 'broadcastCount',
      title: 'Sent',
      tip: 'Sent broadcasts to this email',
      width: 100
    },
    lastBroadcast: {
      key: 'lastBroadcast',
      title: 'Last',
      tip: 'Last broadcast sent',
      width: 100
    },
    entryType: {
      key: 'type',
      title: 'Source',
      width: 100,
      tip: 'Registry: Patient submitted their contact information for a study | Newsletter: Patient submitted their contact information for the newsletter',
      searchable: true
    },
    nctNumber: {
      key: 'nct_number',
      title: 'NCT',
      tip: 'National Clinical Trial (NCT) Identifier',
      searchable: true,
      width: 'min',
    },
    briefTitle: {
      key: 'brief_title',
      title: 'Brief Title',
      tip: 'Title of the study of interest',
      searchable: true,
      width: 'max',
    },
    briefTitleFix: {
      key: 'title',
      title: 'Brief Title',
      tip: 'Title of the study of interest',
      searchable: true,
      width: 'max',
    },
    revCustomData: {
      key: 'customReview',
      title: 'Reviewed Custom Data',
      tip: 'Check if custom data has been reviewed.',
      searchable: false,
      width: 90,
      type: 'switch',
      action: 'customDataReviewed',
      actionID: 'data:_id'
    },
    dateExcluded: {
      key: 'created_date',
      title: 'Date Excluded',
      tip: 'Date that the trial was excluded.',
      searchable: true,
      sortable: false,
      width: 'min',
    },
    dateAdded: {
      key: 'created_date',
      title: 'Date Added',
      tip: 'Date this trial was created.',
      searchable: false,
      sortable: false,
      width: 'min',
    },
    dateRegistered: {
      key: 'created_date',
      title: 'Date of Referral',
      tip: 'Most recent date of registration',
      searchable: false,
      sortable: false,
      width: 145
    },
    comments: {
      key: 'comments',
      title: 'Comments',
      tip: 'Comments left by users.',
      searchable: true,
      width: 'min',
      minWidth: 220
    },
    isExcluded: {
      key: 'excluded',
      title: 'Excluded',
      tip: 'If this trial is excluded.',
      searchable: true,
      width: 110,
    },
    reviewed: {
      key: 'reviewed',
      title: 'QC',
      tip: 'If this trial has been reviewed by study admins.',
      searchable: false,
      width: 100,
      type: 'switch',
      action: 'reviewedSwitch',
      actionID: 'data:nct_number'
    },
    approved: {
      key: 'approved',
      title: 'Display',
      tip: 'The study will not appear on the XpertTrial platform until it has been approved',
      searchable: false,
      width: 90,
      type: 'switch',
      action: 'approveSwitch',
      actionID: 'data:nct_number'
    },
    customized: {
      key: 'cusomized',
      title: 'Customized',
      tip: 'If this trial has been customized.',
      searchable: false,
      width: 'min',
    },
    patName: {
      key: 'firstName',
      title: 'Patient Name',
      tip: "Patient’s name",
      searchable: true,
      width: 160,
    },
    patEmail: {
      key: 'email',
      title: 'Patient Email',
      tip: "Patient’s email address",
      searchable: true,
      width: 170,
    },
    studyTitle: {
      key: 'brief_title',
      title: 'Study Title',
      tip: 'Title of the study for which the patient submitted their contact information',
      searchable: true,
      width: 'max',
      minWidth: 250
    },
    title: {
      key: 'title',
      title: 'Study Title',
      tip: 'Title for study patient participated in.',
      searchable: true,
      width: 'max',
    },
    studyStatus: {
      key: 'status',
      title: 'Study Status',
      tip: 'Current status of the study.',
      searchable: true,
      width: 'min',
      minWidth: 150
    },
    leadSponsor: {
      key: 'sponsors->lead_sponsor->agency',
      title: 'Lead Sponsor',
      tip: 'The lead sponsor of the study.',
      searchable: true,
      width: 'max',
    },
    senderN: {
      key: 'senderName',
      title: 'Provider\'s Name' ,
      tip: 'Name of the referring provider',
      searchable: true,
      width: 230,
    },
    location: {
      key: 'location',
      title: 'Location',
      tip: 'Location for this study',
      searchable: false,
      width: 'max',
    },
    contacts: {
      key: 'contacts',
      title: 'PI',
      tip: 'List of PIs available for this study',
      searchable: true,
      width: 'max',
      listKey: 'name',
    },
    pcrc: {
      key: 'pcrc',
      title: 'PCRC',
      tip: 'List of contacts available for this study',
      searchable: true,
      width: 'max',
      listKey: 'name',
    },
    additional: {
      key: 'additional',
      title: 'Additional',
      tip: 'List of additional contacts available for this study',
      searchable: true,
      width: 'max',
      listKey: 'email',
    },
    status: {
      key: 'triage',
      title: 'Status',
      tip: 'Current status of the patient in the context of trial enrollment',
      searchable: true,
      width: 'min',
      minWidth: 100,
    },
    removePriorityTrial: {
      key: null,
      title: 'Remove Trial',
      tip: 'Remove selected trial from the list',
      type: 'button',
      searchable: false,
      sortable: false,
      width: 120,
      action: 'removeTrial',
      actionID: 'data:_id',
      icon: <svg style={{display: 'block', width: '25px', margin: '0 auto'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M133.1 128l23.6 290.7c0 16.2 13.1 29.3 29.3 29.3h141c16.2 0 29.3-13.1 29.3-29.3L379.6 128H133.1zm61.6 265L188 160h18.5l6.9 233h-18.7zm70.3 0h-18V160h18v233zm52.3 0h-18.6l6.8-233H324l-6.7 233zM364 92h-36l-26.3-23c-3.7-3.2-8.4-5-13.2-5h-64.8c-4.9 0-9.7 1.8-13.4 5L184 92h-36c-17.6 0-30 8.4-30 26h276c0-17.6-12.4-26-30-26z"/></svg>,
    },
    removePITrial: {
      key: null,
      title: 'Remove Trial',
      tip: 'Remove selected trial from your list.',
      type: 'button',
      searchable: false,
      sortable: false,
      width: 100,
      action: 'removePITrial',
      actionID: 'data:_id',
      icon: <svg style={{display: 'block', width: '25px', margin: '0 auto'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M133.1 128l23.6 290.7c0 16.2 13.1 29.3 29.3 29.3h141c16.2 0 29.3-13.1 29.3-29.3L379.6 128H133.1zm61.6 265L188 160h18.5l6.9 233h-18.7zm70.3 0h-18V160h18v233zm52.3 0h-18.6l6.8-233H324l-6.7 233zM364 92h-36l-26.3-23c-3.7-3.2-8.4-5-13.2-5h-64.8c-4.9 0-9.7 1.8-13.4 5L184 92h-36c-17.6 0-30 8.4-30 26h276c0-17.6-12.4-26-30-26z"/></svg>,
    },
    emailSender: {
      key: 'senderEmail',
      title: "Sender's Email",
      tip: 'The address that this message was sent from',
      searchable: true,
      width: 'min',
    },
    emailSubject: {
      key: 'subject',
      title: 'Email Subject' ,
      tip: 'The subject of the email broadcast.',
      width: 'min',
      searchable: true,
    },
    emailRecipients: {
      key: 'recipients',
      title: 'Email Recipients',
      tip: 'Recipients of this email broadcast',
      searchable: false,
      width: 'max',
      listKey: 'email',
    },
    emailMessage: {
      key: 'message',
      title: 'Email Message',
      tip: 'Message of this email broadcast',
      searchable: true,
      width: 'max',
    },
    emailQuery: {
      key: 'query',
      title: 'Query',
      tip: 'The terms searched when creating this email broadcast group.',
      searchable: true,
      width: 'min',
    },
    emailDate: {
      key: 'date',
      title: 'Date',
      tip: 'Date this email broadcast was sent.',
      searchable: true,
      width: 'min',
    },
    priorityTrial: {
      key: 'priorityTrial',
      title: 'Priority Trial',
      tip: 'If this trial has been marked as priority trial. It will be on the top of the list page',
      searchable: false,
      width: 120,
      type: 'switch',
      action: 'priorityTrialSwitch',
      actionID: 'data:_id'
    },
    suspendTrial: {
      title: 'Suspend Trial',
      key: 'suspendTrial',
      tip: 'The study will not show up on the XpertTrial platform until the given date',
    },
    startDate: {
      title: 'Start Date',
      key: 'startDate',
      tip: 'The study will show up on the XpertTrial platform from the starting date',
    },
    endDate: {
      title: 'End Date',
      key: 'endDate',
      tip: 'The study will show up on the XpertTrial platform till the ending date',
    },
    studyNotes: {
      title: 'Study Notes',
      key: 'studyNotes',
      tip: 'Notes regarding this trial. This will not show up on the patient facing platform',
    },
    minimumAge: {
      key: 'minAge',
      title: 'Minimum Age(years)',
      tip: 'Minimum Age (years) of patient',
    },
    maximumAge: {
      key: 'maxAge',
      title: 'Maximum Age(years)',
      tip: 'Maximum Age (years) of patient',
    },
    healthyVolunteer: {
      key: 'healthyVolunteers',
      title: 'Maximum Age(years)',
      tip: 'Patient enrolling for Healthy Volunteers',
    },
    primaryPurpose: {
      key: 'primaryPurpose',
      title: 'Primary Purpose',
      tip: 'Primary Purpose',
    },
    allergies: {
      key: 'allergies',
      title: 'Allergies',
      tip: 'Patient having allergy/allergies',
    },
    treatmentStatusInclude: {
      key: 'ts_include',
      title: 'Treatment Status Include',
      tip: 'Present treatment status of the patient',
    },
    treatmentStatusExclude: {
      key: 'ts_exclude',
      title: 'Treatment Status Include',
      tip: 'Ineligible treatment status of the patient',
    },
    diseaseStageInclude: {
      key: 'ds_include',
      title: 'Disease Stage Include',
      tip: 'Present disease stage of the patient',
    },
    diseaseStageExclude: {
      key: 'ds_exclude',
      title: 'Disease Stage Exclude',
      tip: 'Ineligible disease stage of the patient',
    },
    comorb: {
      key: 'comorb',
      title: 'Commodities',
      tip: 'Medical history of patient',
    },
    labs: {
      key: 'lav',
      title: 'Labs',
      tip: 'Lab history',
    },
    vitalSigns: {
      key: 'vital_signs',
      title: 'Labs',
      tip: 'Vital Sign of patient',
    },
    cardiovascularTests: {
      key: 'cardiovascular_tests',
      title: 'Cardio Vascular Tests',
      tip: 'Cardio vascular test of patient',
    },
    lungFunctionTest: {
      key: 'lung_function_test',
      title: 'Lung Functional Tests',
      tip: 'Lung functional test of patient',
    },
    customTitle: {
      title: 'Custom Study Title',
      key: 'customTitle',
      tip: 'The customized title will replace the default study title received from www.clinicaltrials.gov',
    },
    customDescription: {
      title: 'Simplified Description - Patient Version',
      key: 'customDescription',
      tip: 'Study Description - Patient Version is shown on the trial overview page of the public facing platform once the users select Simplified Descriptions'
    },
    studyPopulation: {
      title: 'Simplified Eligibility Criteria',
      key: 'studyPopulation',
      tip: 'Eligibility Criteria - Patient Version is shown on the trial overview page of the public facing platform once the users select Simplified Descriptions'
    },
    simplifiedPrimaryOutcome: {
      title: 'Simplified Primary Outcome',
      key: 'whatsInvolved',
      tip: 'Simplified Primary Outcome is shown on the trial overview page of the public facing platform once the users select Simplified Descriptions'
    },
    extraInfo: {
      title: 'Extra Information',
      key: 'extraInfo',
      tip: 'Any extra trial information that needs to be displayed on the overview page of the public facing platform'
    },
    investigators: {
      title: 'Investigators',
      key: 'investigators',
      tip: 'The information about investigators for this trial'
    },
    studyFlyer: {
      title: 'Study Flyer',
      key: 'flyer',
      tip: 'Any extra trial information that needs to be displayed on the overview page of the public facing platform'
    },
    nameNw: {
      key: 'name',
      title: 'Name',
      tip: 'User’s name',
      searchable: true,
      width: 'max',
      minWidth: 120,
    },
    fn: {
      key: 'fName',
      title: 'FN',
      tip: 'User’s first name',
      searchable: true,
      width: 'max',
      minWidth: 120,
    },
    ln: {
      key: 'lName',
      title: 'LN',
      tip: 'User’s last name',
      searchable: true,
      width: 'max',
      minWidth: 120,
    },
    roleEmr: {
      key: 'role',
      title: 'Role',
      tip: 'User’s Role',
      searchable: true,
      width: 'max',
      minWidth: 120,
    },
    emailNw: {
      key: 'email',
      title: 'Email',
      tip: 'User’s email address',
      searchable: true,
      width: 'max',
      minWidth: 120,
    },
    registryCount: {
      key: 'registryCount',
      title: 'Referrals',
      tip: 'Number of referrals',
      searchable: false,
      width: 100,
    },
    phoneNumberNw: {
      key: 'phoneNumber',
      title: 'Telephone',
      tip: 'User’s telephone number.',
      searchable: true,
      width: 'max',
      minWidth: 120,
    },
    sendersName: {
      key: 'sendersName',
      title: 'Name',
      tip: 'Sender’s name',
      searchable: true,
      width: 150,
    },
    sendersEmail: {
      key: 'sendersEmail',
      title: 'Email',
      tip: 'Sender’s email address',
      searchable: true,
      width: 'max',
      minWidth: 120,
    },
    name: {
      key: 'name',
      title: 'Name',
      tip: 'User’s name',
      searchable: true,
      width: 'max',
    },
    email: {
      key: 'email',
      title: 'Email',
      tip: 'User’s email address',
      searchable: true,
      width: 'max',
      minWidth: 200,
    },
    phoneNumber: {
      key: 'phoneNumber',
      title: 'Telephone',
      tip: 'User’s telephone number.',
      searchable: true,
      width: 150,
    },
    phone: {
      key: 'phone',
      title: 'Telephone',
      tip: 'User’s telephone number.',
      searchable: true,
      width: 'max',
    },
    trials: {
      key: 'trials',
      title: 'NCTs',
      tip: 'Trial Ncts assigned to the user',
      searchable: true,
      width: 120
    },
    instance: {
      key: 'instance',
      title: 'Instance',
      tip: 'User’s instance',
      searchable: true,
      width: 120,
      minWidth: 120
    },
    isPi: {
      key: 'isPi',
      title: 'Principal Investigator',
      tip: 'Is Principal Investigator',
      searchable: false,
      width: 180,
      minWidth: 150
    },
    role: {
      key: 'role',
      title: 'User Role',
      tip: 'User Role',
      searchable: true,
      width: 180,
      minWidth: 150
    },
    studyTeams: {
      key: 'accountType',
      title: 'Study Team',
      tip: 'Is the user part of a study team',
      searchable: true,
      width: 180,
      minWidth: 150
    },
    community: {
      key: 'community',
      title: 'Community',
      tip: 'Community',
      searchable: false,
      width: 180,
      minWidth: 150
    },
    marketing: {
      key: 'marketing',
      title: 'Marketing',
      tip: 'Marketing',
      searchable: false,
      width: 180,
      minWidth: 150
    },
    appAccess: {
      key: 'appAccess',
      title: 'App Access',
      tip: 'The apps the user has access to',
      searchable: false,
      width: 150
    },
    affiliation: {
      key: 'affiliation',
      title: 'Affiliation',
      tip: "User's affiliation",
      searchable: false,
      width: 100
    },
    division: {
      key: 'division',
      title: 'Division',
      tip: 'User’s division',
      searchable: false,
      width: 100
    },
    mrn: {
      key: 'mrn',
      title: 'MRN',
      tip: 'Patient’s mrn',
      width: 100
    },
    patPhone: {
      key: 'telephone',
      title: 'Telephone',
      tip: 'Patient’s phone number',
    },
    source: {
      key: 'source',
      title: 'Source',
      tip: 'Patient’s app',
    },
    senderName: {
      key: 'senderName',
      title: 'Sender’s name',
      tip: 'Sender’s name'
    },
    senderEmail: {
      key: 'senderEmail',
      title: 'Sender’s email',
      tip: 'Sender’s email address'
    },
    patComments: {
      key: 'comments',
      title: 'Comments',
      tip: 'Comments left by patient'
    },
    trialNct: {
      key: 'nct',
      title: 'NCT',
      tip: 'NCT number of the trial.',
      searchable: true,
      width: 120,
    },
    trialLocation: {
      key: 'location',
      title: 'Location',
      tip: 'Study Location',
      searchable: true,
      width: 'max',
    },
    specialty: {
      key: 'specialty',
      title: 'Specialty',
      tip: 'Specialty Name',
      width: 'max',
    },
    oncology: {
      key: 'oncology',
      title: 'Oncology',
      tip: 'Oncology Contacts',
      width: 90
    },
    cardiology: {
      key: 'cardiology',
      title: 'Cardiology',
      tip: 'Cardiology Contacts',
      width: 'max',
    },
  }, // end headers
}
